import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Maximize2, X } from 'lucide-react';
import { useEhMobile } from '../../hooks/useEhMobile';

const API_ORIGIN = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1').replace(/\/api\/v1$/, '');

// Banner de capa no topo do formulário público (FormularioDinamico.js) —
// troca de imagem por <picture>/<source media>, não CSS: assim o navegador
// baixa só o arquivo que vai usar (a "outra" nem chega a ser requisitada),
// diferente de esconder com display:none. 639px é o breakpoint `sm` do
// Tailwind usado no resto do projeto. Sem capaMobile, cai pra capa normal
// em qualquer tamanho de tela — comportamento antigo preservado.
//
// Botão de tela cheia sempre visível (não só no hover) — em touch não
// existe hover persistente, e ver a imagem grande faz sentido em qualquer
// tamanho de tela, não só desktop. O lightbox mostra a MESMA imagem que já
// estava visível na miniatura (capa ou capaMobile, via useEhMobile), não a
// outra variante — trocar de imagem ao abrir seria confuso.
const ImagemCapaEnquete = ({ capa, capaMobile }) => {
  const [aberto, setAberto] = useState(false);
  const ehMobile = useEhMobile();

  useEffect(() => {
    if (!aberto) return undefined;
    const aoTeclar = (evento) => {
      if (evento.key === 'Escape') setAberto(false);
    };
    document.addEventListener('keydown', aoTeclar);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', aoTeclar);
      document.body.style.overflow = '';
    };
  }, [aberto]);

  if (!capa) return null;

  const srcExibido = ehMobile && capaMobile ? capaMobile : capa;

  return (
    <>
      <div className="relative">
        <picture>
          {capaMobile && <source media="(max-width: 639px)" srcSet={`${API_ORIGIN}${capaMobile}`} />}
          <img
            src={`${API_ORIGIN}${capa}`}
            alt=""
            className="w-full max-h-64 object-cover rounded-lg mb-4"
          />
        </picture>

        <button
          type="button"
          onClick={() => setAberto(true)}
          aria-label="Ver imagem em tela cheia"
          title="Ver em tela cheia"
          className="absolute top-3 right-3 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full shadow-md backdrop-blur-sm transition-colors"
        >
          <Maximize2 className="w-4 h-4" />
        </button>
      </div>

      <AnimatePresence>
        {aberto && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
            onClick={() => setAberto(false)}
            role="dialog"
            aria-modal="true"
            aria-label="Imagem de capa em tela cheia"
          >
            <button
              type="button"
              onClick={() => setAberto(false)}
              aria-label="Fechar"
              className="absolute top-4 right-4 text-white/80 hover:text-white p-2"
            >
              <X className="w-7 h-7" />
            </button>

            <motion.img
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ type: 'spring', stiffness: 300, damping: 28 }}
              src={`${API_ORIGIN}${srcExibido}`}
              alt=""
              onClick={(evento) => evento.stopPropagation()}
              className="max-w-full max-h-full object-contain rounded-lg"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ImagemCapaEnquete;
